import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useCurrentCarAnnouncementCarHotbidReset() {
  const { startListen } = useWebSocketStore()
  const { updateAnnouncementCarData } = useUpdateCar()

  const carHotbidReset = () => {
    startListen({
      eventName: 'premium.CAR_HOTBID_RESET',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, auctionId } = event.context

        updateAnnouncementCarData(auctionId, (item) => {
          if (!item) {
            return item
          }

          if (item.id !== carId) {
            return item
          }

          return {
            ...item,
            bids: [
              {
                user_id: Infinity,
                status: Infinity,
                type: Infinity,
                amount: Infinity,
                timestamp: new Date(event.time * 1000).toISOString(),
                agent_bid: false,
                user_nickname: '',
              },
              ...item.bids,
            ],
          }
        })
      },
    })
  }

  return { carHotbidReset }
}
